export var LanguageSelectionVariants;
(function (LanguageSelectionVariants) {
    LanguageSelectionVariants[LanguageSelectionVariants["LIGHT"] = 0] = "LIGHT";
    LanguageSelectionVariants[LanguageSelectionVariants["NORMAL"] = 1] = "NORMAL";
    LanguageSelectionVariants[LanguageSelectionVariants["DARK"] = 2] = "DARK";
})(LanguageSelectionVariants || (LanguageSelectionVariants = {}));
export var MenuPositions;
(function (MenuPositions) {
    MenuPositions[MenuPositions["TOP"] = 0] = "TOP";
    MenuPositions[MenuPositions["BOTTOM"] = 1] = "BOTTOM";
})(MenuPositions || (MenuPositions = {}));
//# sourceMappingURL=enums.js.map